import { Box, makeStyles, Theme, Typography } from '@freighthub/silhouette-core'
import { cloneElement, FC, ReactElement } from 'react'

const useStyles = makeStyles<Theme>((theme) => ({
  icon: {
    height: 80,
    width: 80,
    marginBottom: theme.spacing(2),
  },
}))

interface EmptyViewWithIconProps {
  icon: ReactElement
  text: string
}

export const EmptyViewWithIcon: FC<EmptyViewWithIconProps> = ({ icon, text, ...props }) => {
  const classes = useStyles({})

  return (
    <Box display="flex" flexDirection="column" alignItems="center" {...props}>
      {cloneElement(icon, { className: classes.icon })}
      <Typography color="textSecondary">{text}</Typography>
    </Box>
  )
}
